<template>
    <form>
        <div class="row">
            <div class="small-12 columns">
                <label>
                    Anrede
                    <select v-model="formData.lawform">
                        <option v-for="lawform in selectableLawforms" :key="lawform.value" :value="lawform.value">{{lawform.title}}</option>
                    </select>
                </label>
                <small v-if="showLawformErrorText" class="error">{{validation.lawformErrorText}}</small>
            </div>
            <div class="small-12 columns">
                <label>
                    Vorname
                    <input type="text" v-model="formData.prename">
                </label>
                <small v-if="showPrenameErrorText" class="error">{{validation.prenameErrorText}}</small>
            </div>
            <div class="small-12 columns">
                <label>
                    Nachname
                    <input type="text" v-model="formData.surname">
                </label>
                <small v-if="showSurnameErrorText" class="error">{{validation.surnameErrorText}}</small>
            </div>
            <div class="small-12 columns">
                <label>
                    E-Mail Adresse
                    <input type="email" v-model="formData.mail">
                </label>
                <small v-if="showMailErrorText" class="error">{{validation.mailErrorText}}</small>
            </div>
            <div class="small-12 columns">
                <label>
                    Telefonnummer
                    <input type="text" v-model="formData.phone">
                </label>
                <small v-if="showPhoneErrorText" class="error">{{validation.phoneErrorText}}</small>
            </div>
            <div class="small-12 columns">
                <label>
                    Bestand zum Zeitpunkt des Fahrzeugkaufs eine Rechtsschutzversicherung?
                    <select v-model="formData.has_rsv">
                        <option
                            v-for="selectData in yesNoSelectData"
                            :key="selectData.value"
                            :value="selectData.value"
                        >
                            {{selectData.title}}
                        </option>
                    </select>
                </label>
                <small class="error" v-if="showHasRsvErrorText">
                    {{ validation.hasRsvErrorText }}
                </small>
            </div>
            <div class="small-12 columns">
                <label>
                    Fahrzeugschein (<a href="https://upload.wikimedia.org/wikipedia/commons/d/d8/Zulassungsbescheinigung-I.1.jpg" target="_blank">Zulassungsbescheinigung Teil 1</a>)
                    <input type="file" v-on:change="onFileInputChange" :accept="acceptedFileTypes">
                </label>
                <small v-if="showFileErrorText" class="error">{{validation.fileErrorText}}</small>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        name: "KBAForm",
        data: () => ({
            formData: {
                lawform:                null,
                prename:                null,
                surname:                null,
                mail:                   null,
                phone:                  null,
                has_rsv:                null,
                vehicle_registration: {
                    title:          null,
                    mime:           null,
                    data_base64:    null
                }
            },
            vehicle_registration: null,
            validation: {
                emptyErrorText:         'Bitte Feld ausfüllen',
                lawformErrorText:       undefined,
                prenameErrorText:       undefined,
                surnameErrorText:       undefined,
                mailErrorText:          undefined,
                fileErrorText:          undefined,
                phoneErrorText:         undefined,
                hasRsvErrorText:        undefined
            },
            selectableLawforms: [
                {
                    title: 'Herr',
                    value: 1
                },
                {
                    title: 'Frau',
                    value: 2
                }
            ],
            allowedFileTypes: [
                'application/pdf',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/msword',
                'image/jpeg',
                'image/jpg',
                'image/png'
            ],
            yesNoSelectData: [
                {
                    value: true,
                    title: 'Ja'
                },
                {
                    value: false,
                    title: 'Nein'
                },
            ]
        }),
        computed: {
            acceptedFileTypes()
            {
                return this.allowedFileTypes.join(', ');
            },
            showLawformErrorText()
            {
                return this.validation.lawformErrorText !== null && this.validation.lawformErrorText !== undefined;
            },
            showPrenameErrorText()
            {
                return this.validation.prenameErrorText !== null && this.validation.prenameErrorText !== undefined;
            },
            showSurnameErrorText(){
                return this.validation.surnameErrorText !== null && this.validation.surnameErrorText !== undefined;
            },
            showMailErrorText(){
                return this.validation.mailErrorText !== null && this.validation.mailErrorText !== undefined;
            },
            showFileErrorText(){
                return this.validation.fileErrorText !== null && this.validation.fileErrorText !== undefined;
            },
            showPhoneErrorText(){
                return this.validation.phoneErrorText !== null && this.validation.phoneErrorText !== undefined;
            },
            showHasRsvErrorText(){
                return this.validation.hasRsvErrorText !== null && this.validation.hasRsvErrorText !== undefined;
            },
        },
        methods: {
            onFileInputChange(changeEvent)
            {
                if(changeEvent.target.files.length > 0)
                    this.vehicle_registration = changeEvent.target.files[0];
            },
            validateForm()
            {
                this.validateLawform();
                this.validatePrename();
                this.validateSurname();
                this.validateMail();
                this.validateFile();
                this.validatePhone();
                this.validateHasRsv();

                if(this.isFormValid())
                {
                    this.readRelevantFileInformation();
                    this.readFileAsBase64(this.emitChangedData);
                }
            },
            emitChangedData()
            {
                this.$emit('change', this.formData);
            },
            async readFileAsBase64(callback)
            {
                let me          = this;
                let fileReader  = new FileReader();

                fileReader.readAsDataURL(this.vehicle_registration);

                fileReader.onloadend = function(){
                    let splittedString = fileReader.result.split(',');
                    me.formData.vehicle_registration.data_base64 = splittedString[1];

                    if(callback !== null && callback !== undefined)
                        callback();
                };
            },
            checkIsEmpty(valueToCheck)
            {
                if(valueToCheck === null || valueToCheck === undefined || valueToCheck === '')
                    return true;

                return false;
            },
            validateLawform()
            {
                if(this.checkIsEmpty(this.formData.lawform))
                    this.validation.lawformErrorText = this.validation.emptyErrorText;
                else
                {
                    this.validation.lawformErrorText = null;
                }
            },
            validatePrename()
            {
                if(this.checkIsEmpty(this.formData.prename))
                    this.validation.prenameErrorText = this.validation.emptyErrorText;
                else
                {
                    //TODO
                    this.validation.prenameErrorText = null;
                }
            },
            validateSurname()
            {
                if(this.checkIsEmpty(this.formData.surname))
                    this.validation.surnameErrorText = this.validation.emptyErrorText;
                else
                {
                    //TODO
                    this.validation.surnameErrorText = null;
                }
            },
            validateMail()
            {
                if(this.checkIsEmpty(this.formData.mail))
                    this.validation.mailErrorText = this.validation.emptyErrorText;
                else if(/.+@.+\..+/.test(this.formData.mail) === false)
                    this.validation.mailErrorText = 'Bitte geben Sie eine gültige E-Mail Adresse ein';
                else
                {
                    //TODO
                    this.validation.mailErrorText = null;
                }
            },
            validateFile()
            {
                if(this.checkIsEmpty(this.vehicle_registration))
                    this.validation.fileErrorText = this.validation.emptyErrorText;
                else if(this.checkIsIllegalFileType(this.vehicle_registration.type))
                    this.validation.fileErrorText = 'Bitte wählen Sie eine PDF-, Word- oder Bilddatei aus';
                else
                {
                    //TODO
                    this.validation.fileErrorText = null;
                }
            },
            validatePhone()
            {
                if(this.checkIsEmpty(this.formData.phone))
                    this.validation.phoneErrorText = this.validation.emptyErrorText;
                else if (this.formData.phone.length < 5)
                    this.validation.phoneErrorText = 'Bitte mindestens 5 Zeichen eingeben';
                else if (/^\d+$/.test(this.formData.phone) === false)
                    this.validation.phoneErrorText = 'Bitte nur Zahlen eingeben'
                else
                {
                    //TODO
                    this.validation.phoneErrorText = null;
                }
            },
            validateHasRsv()
            {
                if(this.checkIsEmpty(this.formData.has_rsv))
                    this.validation.hasRsvErrorText = 'Bitte einen Wert wählen';
                else
                {
                    //TODO
                    this.validation.hasRsvErrorText = null;
                }
            },
            checkIsIllegalFileType(fileType)
            {
                return !this.allowedFileTypes.includes(fileType);
            },
            isFormValid()
            {
                let isValid = true;

                isValid = this.validation.lawformErrorText === null;
                isValid = isValid && (this.validation.prenameErrorText === null);
                isValid = isValid && (this.validation.surnameErrorText === null);
                isValid = isValid && (this.validation.mailErrorText === null);
                isValid = isValid && (this.validation.fileErrorText === null);
                isValid = isValid && (this.validation.phoneErrorText === null);
                isValid = isValid && (this.validation.hasRsvErrorText === null);

                return isValid;
            },
            readRelevantFileInformation()
            {
                this.formData.vehicle_registration.mime = this.vehicle_registration.type;
                this.formData.vehicle_registration.title = this.vehicle_registration.name;
            },
            onFormDataValidated()
            {
                if(this.isFormValid())
                    this.emitChangedData();
                else
                    this.$emit('change', null);
            }
        },
        watch: {
            'formData.lawform'()
            {
                this.validateLawform();
                this.onFormDataValidated();
            },
            'formData.prename'()
            {
                this.validatePrename();
                this.onFormDataValidated();
            },
            'formData.surname'()
            {
                this.validateSurname();
                this.onFormDataValidated();
            },
            'formData.mail'()
            {
                this.validateMail();
                this.onFormDataValidated();
            },
            vehicle_registration()
            {
                this.validateFile();

                if(this.isFormValid())
                {
                    this.readRelevantFileInformation();
                    this.readFileAsBase64(this.onFormDataValidated);
                }
            },
            'formData.phone'()
            {
                this.validatePhone();
                this.onFormDataValidated();
            },
            'formData.has_rsv'()
            {
                this.validateHasRsv();
                this.onFormDataValidated();
            },
        }
    }
</script>

<style scoped>

</style>
